import { useState } from "react";
import EmailVerificationStep from "./EmailVerificationStep";
import CodeVerificationStep from "./CodeVerificationStep";
import RegisterForm from "./RegisterForm";

type Step = "email" | "code" | "register";

export default function RegistrationFlow() {
  const [step, setStep] = useState<Step>("email");
  const [verifiedEmail, setVerifiedEmail] = useState("");
  const [codeExpired, setCodeExpired] = useState(false);

  if (step === "email") {
    return (
      <EmailVerificationStep
        expired={codeExpired}
        onSuccess={(email) => {
          setCodeExpired(false);
          setVerifiedEmail(email);
          setStep("code");
        }}
        onSkip={(email) => {
          setVerifiedEmail(email);
          setStep("register");
        }}
      />
    );
  }

  if (step === "code") {
    return (
      <CodeVerificationStep
        email={verifiedEmail}
        onSuccess={() => setStep("register")}
        onExpired={() => {
          setCodeExpired(true);
          setStep("email");
        }}
        onBack={() => {
          setCodeExpired(false);
          setStep("email");
        }}
        onSkip={() => setStep("register")}
      />
    );
  }

  return (
    <RegisterForm
      verifiedEmail={verifiedEmail}
      onVerificationExpired={() => {
        setCodeExpired(true);
        setStep("email");
      }}
    />
  );
}
